module.exports = {
  online: 0,
  offline: 1,
  busy: 2
}
